import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module18Nav = () => {
  const { module18 } = useSelector((state) => state.module18, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module18Images/JourneyMap18-01.png';
    const mobileImage =
      '/Module18Images/JourneyMap18-01_phone.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module18Images/Unit4_Mod3BG_Final.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module8Images/Module8NavImages/JourneyMap_Mod3_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module8Images/Module8NavImages/JourneyMap_Mod3_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/resolveconflict',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/resolve_conflict/resolve_conflict_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/ask_affirmation.mp4`,
      `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_5.mp4`,
      'appfiles/resolve_conflict/practice_bus_1.mp4',
      `userfiles/${module18.StudentID}/resolve_conflict_practice_1_5.mp4`,
      'appfiles/resolve_conflict/practice_bus_2.mp4',
      `userfiles/${module18.StudentID}/resolve_conflict_practice_2_5.mp4`,
      'appfiles/resolve_conflict/practice_bus_3.mp4',
      `userfiles/${module18.StudentID}/resolve_conflict_practice_3_5.mp4`,
      `influencers/${login.influencerid2}/conversation_affirmation.mp4`,
      `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_6.mp4`,
      `influencers/${login.influencerid1}/answer_affirmation.mp4`,
      `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid3}/ask_affirmation.mp4`,
      `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_8.mp4`,
      `influencers/${login.influencerid4}/ask_affirmation.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE18'
          module={module18}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit4'
          nextDestiny='/unit4'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={4}
          animal={MediaService.getImage('/Images/Button_Lizardhead.png', login)}
        />
      )}
    </>
  );
};
export default Module18Nav;
